import React from 'react'
import PropTypes from 'prop-types'
import ChevronRight from '@mui/icons-material/ChevronRight'

const ChevronRightIcon = ({ height, width, ...more }) => {
	
	return (
		<ChevronRight
			height={height}
			width={width}
			{...more}
		/>
	)
}

ChevronRightIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ChevronRightIcon
